import { Injectable } from '@angular/core';
import { Destination } from '@prlw/core/destinations/destination.entity';
import { Modifier } from '@prlw/core/monitor/types/common';

@Injectable({
  providedIn: 'root',
})
export class HighlightChangesService {
  private readonly valuesRegistry = new Map<string, number>();
  private readonly depsRegistry = new Map<
    string,
    [Modifier | null, Destination | null]
  >();

  public saveValue(
    key: string,
    value: number,
    deps: [Modifier | null, Destination | null],
  ): void {
    this.valuesRegistry.set(key, value);
    this.depsRegistry.set(key, deps);
  }

  public getValue(key: string): number | undefined {
    return this.valuesRegistry.get(key);
  }

  public getDeps(
    key: string,
  ): [Modifier | null, Destination | null] | undefined {
    return this.depsRegistry.get(key);
  }
}
